import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix/core';
import {
    OFFER_CARD_OFFER_COUNTER_HEADLINE,
    OFFER_CARD_OFFER_HEADLINE,
    OFFER_CARD_OFFER_SUBLINE,
} from 'Container/OfferDisplay/constant';
import {createHeadline, IHeadlineProperties} from '@vfde-brix/headline';

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

/**
 * Headline will be always shown
 * Content depends on wether default offers are displayed or soecial offers (coming from JSON)
 * @param element
 * @param offerCounter
 * @param numberOfOffers
 * @param isDefault
 */
const renderHeadline = (element: HTMLElement, offerCounter: number, numberOfOffers: number, isDefault: boolean) => {

    // First Headline only in first element
    if (0 < offerCounter) {
        return;
    }

    let content: string;
    if (true === isDefault) {
        content = 'Ideen für Produkt-Kombinationen';
    } else {
        if (1 === numberOfOffers) {
            content = 'Dein persönliches Angebot';
        } else {
            content = 'Deine persönlichen Angebote';
        }
    }

    const accordionContentDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(OFFER_CARD_OFFER_HEADLINE)[0];
    const headlineProperties: IHeadlineProperties = {
        optTag: 'h2',
        stdContent: content,
        optAlign: 'center',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };
    createHeadline(accordionContentDIV, headlineProperties);
};

/**
 * Subline will be always shown
 * Content depends on wether default offers are displayed or special offers (coming from JSON)
 * @param element
 * @param offerCounter
 * @param numberOfOffers
 * @param isDefault
 */
const renderSubline = (element: HTMLElement, offerCounter: number, numberOfOffers: number, isDefault: boolean) => {

    let toBeDisplayed = true;
    if (0 < offerCounter) {
        toBeDisplayed = false;
    }

    if (false === toBeDisplayed) {
        return;
    }

    let content: string;
    if (true === isDefault) {
        content = 'Wähl oben Produkte für Dein persönliches Angebot aus';
    } else {
        if (1 === numberOfOffers) {
            content = 'Passend zu Deiner Produktauswahl';
        } else {
            content = `Angebot ${ offerCounter + 1} passend zu Deiner Auswahl`;
        }

    }

    const accordionContentDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(OFFER_CARD_OFFER_SUBLINE)[0];
    const headlineProperties: IHeadlineProperties = {
        optTag: 'h4',
        stdContent: content,
        spacing: '100',
        optAlign: 'center',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };
    createHeadline(accordionContentDIV, headlineProperties);

};

/**
 * Offer Counter will only be shown on second, third..... offer.
 * Content depends on wether default offers are displayed or special offers (coming from JSON)
 * @param element
 * @param offerCounter
 * @param numberOfOffers
 * @param isDefault
 */
const renderOfferCounter = (element: HTMLElement, offerCounter: number, numberOfOffers: number, isDefault: boolean) => {

    let toBeDisplayed = false;
    if (true === isDefault) {
        // always show, when default offers are displayed
        toBeDisplayed = true;
    } else {
        // when special offers are displayed,  only if more than one offer is displayed, render headline: "Angebot 1", "Angebot 2" ....
        if (1 < numberOfOffers && 0 < offerCounter) {
            toBeDisplayed = true;
        }
    }

    if (false === toBeDisplayed) {
        return;
    }

    let content: string;
    if (true === isDefault) {
        content = `Angebot ${ offerCounter + 1}`;
    } else {
        content = `Angebot ${ offerCounter + 1} passend zu Deiner Auswahl`;
    }

    const accordionContentDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(OFFER_CARD_OFFER_COUNTER_HEADLINE)[0];
    const headlineProperties: IHeadlineProperties = {
        optTag: 'h4',
        stdContent: content,
        spacing: '100',
        optAlign: 'center',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };
    createHeadline(accordionContentDIV, headlineProperties);

};

/**
 * renders the multi divider dynamically
 * @param element
 * @offerCounter  offer x von y
 * @numberOfOffers count of offers
 * @isDefault is displayed offer default
 */
export const renderHeadlines = (element: HTMLElement, offerCounter: number, numberOfOffers: number, isDefault: boolean) => {

    renderHeadline(element, offerCounter, numberOfOffers, isDefault);
    renderSubline(element, offerCounter, numberOfOffers, isDefault);
    renderOfferCounter(element, offerCounter, numberOfOffers, isDefault);

};
